import { render } from "./Schedule.vue?vue&type=template&id=180b36b6"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=180b36b6&lang=sass"

import exportComponent from "/creek/ws/studio-website-elements/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__